import axios from "axios";

export const fetchDecisionAnalytics = async () => {
  const { data } = await axios.get(
    "/api/digital-risk/portfolio-decision/decision-analytics/",
    { withCredentials: true }
  );
  return data;
};
